export enum Service {
  AddUsers = 1,
  Hrv,
  Gait,
  Posture,
  Afib,
  LongReport,
  EcgDisplay,
  NotUsed,
  Breath
}
